export interface Category {
  key: string;
  name: string;
  url: string;
}

export const categories: Category[] = [
  { key: 'shoes', name: 'category.shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { key: 'hoodies', name: 'category.hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { key: 'tshirts', name: 'category.tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { key: 'jackets', name: 'category.jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { key: 'pants', name: 'category.pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { key: 'headwear', name: 'category.headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { key: 'sets', name: 'category.sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { key: 'underwear', name: 'category.underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { key: 'jersey', name: 'category.jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { key: 'accessories', name: 'category.accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { key: 'bags', name: 'category.bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { key: 'belts', name: 'category.belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { key: 'perfumes', name: 'category.perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { key: 'other', name: 'category.other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];